import styles from "./SettingsRow.module.scss";

interface SettingsRowProps {
  label: string;
  /** Shown to the right of the label, greyed: a balance, a saved contact. */
  value?: string;
  /**
   * Trailing icon. A chevron for a screen inside the app, an arrow out of it
   * for anything that hands the guest to their browser or mail client.
   */
  iconName?: string;
  onClick: () => void;
}

/** One tappable line of a settings group. */
function SettingsRow(props: SettingsRowProps) {
  const { label, value, iconName = "las la-angle-right", onClick } = props;

  return (
    <div
      className={styles.settingsRow}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClick();
        }
      }}
    >
      {/* Condensed and uppercase, the way every other tile in the app titles
          itself. */}
      <p className={`body-bold-medium ${styles.settingsRowLabel}`}>{label}</p>
      <div className={styles.settingsRowEnd}>
        {value ? (
          <p className={`body-medium ${styles.settingsRowValue}`}>{value}</p>
        ) : null}
        <i className={`${iconName} icon-big ${styles.settingsRowIcon}`} />
      </div>
    </div>
  );
}

export default SettingsRow;
